import { authApi } from '@shared/api/base/auth-base';
import { API_AUTH_PREFIX } from '@shared/config/api/api-prefixes';

export const logoutApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        logout: build.mutation<void, void>({
            query() {
                return {
                    url: `${API_AUTH_PREFIX}/logout`,
                    method: 'POST',
                };
            },
        }),
    }),
});

export const { useLogoutMutation } = logoutApi;
